import React from 'react';

interface SuccessModalProps {
    isOpen: boolean;
    onClose: () => void;
    title?: string;
    message?: string;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
    isOpen,
    onClose,
    title = 'Success!',
    message = 'Your action was completed successfully.',
}) => {
    if (!isOpen) return null;

    return (
        <>
            {/* Backdrop */}
            <div
                className="fixed inset-0 z-[600] backdrop-blur-[1px] transition-opacity animate-fadeIn"
                onClick={onClose}
            />

            {/* Success Modal */}
            <div className="fixed inset-0 z-[601] flex items-center justify-center p-4">
                <div className="bg-white rounded-2xl p-8 max-w-sm w-full animate-scaleIn border border-[#e1e1e1]">
                    <div className="flex flex-col items-center text-center">
                        {/* Success Icon with animation */}
                        <div className="mb-4 animate-bounceIn">
                            <svg className="w-16 h-16 text-green-500" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                            </svg>
                        </div>

                        {/* Success Message */}
                        <h3 className="text-2xl font-bold text-[#151515] mb-2">{title}</h3>
                        <p className="text-sm text-neutral-600 mb-6">{message}</p>

                        {/* Close Button */}
                        <button
                            onClick={onClose}
                            className="w-full rounded-lg py-3 text-sm font-semibold text-white bg-[#151515] hover:bg-[#2a2a2a] transition-colors"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SuccessModal;
